module.exports = __webpack_public_path__ + "img/6.c5c93521.png";